export const nodeBeingUsedByAnyMember = (members, node) => {
  return !members.every((member) => member.n1 !== node && member.n2 !== node);
};
